import { getApp, getApps, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDIFWAAyVus-ci_9V5InlZjqHI20D4WtnQ",
  authDomain: "eapp-ks.firebaseapp.com",
  projectId: "eapp-ks",
  storageBucket: "eapp-ks.appspot.com",
  messagingSenderId: "71876582762",
  appId: "1:71876582762:web:44d52dd1e97b68d33b1913",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
export const db = getFirestore(app);
